/**
 * First Sale Tracker Factory
 *
 * Factory for creating, searching, and finding FirstSaleTracker model instances.
 * Delegates CRUD operations to BaseModelFactory with the appropriate Service and Model.
 */

import BaseModelFactory from './base.factory'
import FirstSaleTrackerService from './../services/FirstSaleTracker.service'
import FirstSaleTracker from './../models/first-sale-tracker.model'

class FirstSaleTrackerFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: FirstSaleTrackerService, Model: FirstSaleTracker }
    )

  static findById = async id =>
    await this._findBy({ id: id }, { Service: FirstSaleTrackerService, Model: FirstSaleTracker })

  static findAllBy = async search =>
    await this._findAllBy(search, {
      Service: FirstSaleTrackerService,
      Model: FirstSaleTracker,
    })

  static create = payload =>
    this._create(payload, {
      Service: FirstSaleTrackerService,
      Model: FirstSaleTracker,
    })
}

export default FirstSaleTrackerFactory
